import script from "./RadioButtonGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=ts&setup=true"

import "./RadioButtonGroup.vue?vue&type=style&index=0&id=dce73e5e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dce73e5e"]])

export default __exports__